import React from 'react';
import CustomTable from '../../../../components/table/CustomTable';
import AccessLogTabApp from '../AccessLogTabApp';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const AccessLogTab = ({ employeeId, setCriteria, option, materialId }) => {
    const { tableId, searchId, thead, tbody, getActionsButtons, pagination } = AccessLogTabApp({
        employeeId,
        setCriteria,
        option,
        materialId
    });
    return (
        <div className={'mt-3'}>
            <CustomTable
                tableId={tableId}
                searchId={searchId}
                checkbox={false}
                thead={thead}
                tbody={tbody}
                columnActions={false}
                getActionsButtons={getActionsButtons}
                textNotInformation={'no_access_log'}
                withoutHeight={false}
                inModal={true}
            />
            {pagination()}
        </div>
    );
};

export default AccessLogTab;
